module.exports = __webpack_public_path__ + "img/sc.90758860.png";